import angular from 'angular';
import { postTabularMultihubComponent } from './postTabularMultihubComponent';

angular
	.module('sh.postTabularMultihub', ['sh.dateFormat', 'sh.modal', 'ui.router', 'sh.nl2br'])
	.component('shPostTabularMultihub', postTabularMultihubComponent());
